// A presentation checkpoint never grants completion or rewrites Attempts.
export const checkpointKey=(session:string)=>`mandarino:learning-position:${session}`;
export function savedLearningPosition(session:string){
 try{return JSON.parse(sessionStorage.getItem(checkpointKey(session))??'null');}catch{return null;}
}
/** Keep the server cursor when no finer local page checkpoint exists. */
export function lessonResumeHref(lessonId:string,resume:{sessionId:string;sectionId?:string|null}){
 const base=`/lesson/${lessonId}/session/${resume.sessionId}`;
 // LearningEntry restores the full item/page checkpoint, including completed replay.
 if(savedLearningPosition(resume.sessionId))return base;
 return resume.sectionId?`${base}?sectionId=${encodeURIComponent(resume.sectionId)}`:base;
}
